import React, { ReactNode } from 'react'


import { TileContainer } from './styles'
import { useTileContext } from '../Context'

interface IProps {
  onSelection: () => void
  onPress: () => void
  children: ReactNode
  tileBackground: string
}

export function Root({
  onSelection,
  onPress,
  children,
  tileBackground,
}: IProps) {
  const { isSelectEnabled, isChecked, setIsChecked, isSelectable } =
    useTileContext()

  function handleSelection() {
    setIsChecked((state) => !state)
    onSelection()
  }

  return (
    <div
      onClick={isSelectable && isSelectEnabled ? handleSelection : onPress}
      style={{ cursor: 'pointer' }}
    >
      <TileContainer tileBackground={tileBackground} isSelected={isChecked}>
        {children}
      </TileContainer>
    </div>
  )
}
